(function () {
  'use strict';
  if (window.__ttLanderMidnight) { window.__ttLanderMidnight(); return; }
  const roots = new Set();
  let interval = null;
  function secondsUntilMidnight(now) {
    const end = new Date(now.getTime());
    end.setHours(24, 0, 0, 0);
    return Math.max(0, Math.floor((end - now) / 1000));
  }
  function tick() {
    if (document.hidden) return;
    const seconds = secondsUntilMidnight(new Date());
    const values = { h: Math.floor(seconds / 3600), m: Math.floor(seconds / 60) % 60, s: seconds % 60 };
    const padded = Object.fromEntries(Object.entries(values).map(([key, value]) => [key, String(value).padStart(2, '0')]));
    for (const root of roots) {
      if (!root.isConnected) { roots.delete(root); continue; }
      for (const key of ['h', 'm', 's']) root.querySelectorAll('[data-tt-midnight-' + key + ']').forEach(el => { el.textContent = padded[key]; });
      root.querySelectorAll('[data-tt-timer]').forEach(timer => { for (const key of ['h', 'm', 's']) { const el = timer.querySelector('[data-' + key + ']'); if (el) el.textContent = padded[key]; } });
      root.querySelectorAll('[data-tt-countdown-mirror], [data-tt-minitimer]').forEach(el => { el.textContent = padded.h + ':' + padded.m + ':' + padded.s; });
    }
    if (!roots.size && interval !== null) { clearInterval(interval); interval = null; }
  }
  function refresh() {
    document.querySelectorAll('[data-tt-midnight-root]').forEach(root => roots.add(root));
    tick();
    if (roots.size && interval === null) interval = setInterval(tick, 1000);
  }
  window.__ttLanderMidnight = refresh;
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
